import { render, staticRenderFns } from "./c_classify.vue?vue&type=template&id=cad3b50e&scoped=true"
import script from "./c_classify.vue?vue&type=script&lang=js"
export * from "./c_classify.vue?vue&type=script&lang=js"
import style0 from "./c_classify.vue?vue&type=style&index=0&id=cad3b50e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad3b50e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cad3b50e')) {
      api.createRecord('cad3b50e', component.options)
    } else {
      api.reload('cad3b50e', component.options)
    }
    module.hot.accept("./c_classify.vue?vue&type=template&id=cad3b50e&scoped=true", function () {
      api.rerender('cad3b50e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_classify.vue"
export default component.exports